class OmetriaFacetSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['search']
  }

  static get requiredExternalElements () {
    return ['content', 'item']
  }

  connectedCallback () {
    if (this._initialized) return

    this.searchInput =
      this.els?.search?.element ||
      this.querySelector('[data-facet-search-el="search"]')
    if (!this.searchInput) return

    this.content =
      this.externalEls?.content?.element ||
      this.closest('[data-facet-search-external-el="content"]')
    if (!this.content) return

    this.items =
      this.externalEls?.item?.elements ||
      Array.from(
        this.content.querySelectorAll('[data-facet-search-external-el="item"]'),
      )
    if (this.items.length === 0) return

    this._initialized = true
    super.connectedCallback()
    this.setupListeners()
    this.handleSearch()
  }

  setupListeners () {
    this.listeners?.removeAll?.()
    super.setupListeners()

    if (!this.searchInput) return
    const add = (el, evt, fn) => {
      if (this.listeners?.add) {
        this.listeners.add(el, evt, fn)
      } else {
        el?.addEventListener?.(evt, fn)
      }
    }
    add(this.searchInput, 'input', () => this.handleSearch())
    add(this.searchInput, 'keyup', () => this.handleSearch())
    add(this.searchInput, 'keydown', () => this.handleSearch())
    add(this.searchInput, 'change', () => this.handleSearch())
    add(this.searchInput, 'paste', () => {
      setTimeout(() => this.handleSearch(), 0)
    })
  }

  normalizeString (str) {
    if (!str) return ''
    return String(str)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
  }

  handleSearch () {
    const searchTerm = this.normalizeString(this.searchInput.value)

    this.items.forEach(item => {
      const filterValue = item.getAttribute('data-filter-value') || ''
      const text = this.normalizeString(filterValue)
      const matches = searchTerm === '' || text.includes(searchTerm)

      if (matches) {
        item.removeAttribute('aria-hidden')
        item.hidden = false
        item.style.display = ''
        item.style.visibility = ''
      } else {
        item.setAttribute('aria-hidden', 'true')
        item.hidden = true
        item.style.display = 'none'
        item.style.visibility = 'hidden'
      }
    })
  }
}

if (!customElements.get('facet-search')) {
  customElements.define('facet-search', OmetriaFacetSearch)
}

;(function () {
  'use strict'

  if (window.omFacetSearchBound) return
  window.omFacetSearchBound = true

  function initFacetSearch () {
    try {
      const searchContainer =
        document.querySelector('site-drawer[key="collection-filters"]') ||
        document
      const facetSearches = searchContainer.querySelectorAll('facet-search')

      facetSearches.forEach(facetSearch => {
        try {
          if (!customElements || !customElements.get('facet-search')) {
            if (customElements && customElements.define) {
              try {
                customElements.define('facet-search', OmetriaFacetSearch)
              } catch (error) {}
            }
          }

          if (customElements && customElements.get('facet-search')) {
            if (customElements.upgrade) {
              try {
                facetSearch._initialized = false
                customElements.upgrade(facetSearch)
              } catch (error) {}
            }

            if (!facetSearch._initialized) {
              try {
                if (facetSearch.connectedCallback) {
                  facetSearch.connectedCallback()
                } else {
                  const instance = new OmetriaFacetSearch()
                  if (instance.connectedCallback) {
                    instance.connectedCallback.call(facetSearch)
                  }
                }
              } catch (error) {}
            }
          }
        } catch (error) {}
      })
    } catch (error) {}
  }

  window.omFacetSearchInit = initFacetSearch

  function runInit () {
    initFacetSearch()
    setTimeout(initFacetSearch, 100)
    setTimeout(initFacetSearch, 500)
    setTimeout(initFacetSearch, 1000)
    setTimeout(initFacetSearch, 2000)
    setTimeout(initFacetSearch, 3000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit)
  } else {
    runInit()
  }

  if (window.MutationObserver && document.body) {
    try {
      const observer = new MutationObserver(mutations => {
        let shouldInit = false

        mutations.forEach(mutation => {
          try {
            if (mutation.addedNodes) {
              mutation.addedNodes.forEach(node => {
                if (node && node.nodeType === 1) {
                  if (
                    (node.matches &&
                      node.matches('site-drawer[key="collection-filters"]')) ||
                    (node.querySelector &&
                      node.querySelector(
                        'site-drawer[key="collection-filters"]',
                      )) ||
                    (node.matches && node.matches('facet-search')) ||
                    (node.querySelector && node.querySelector('facet-search'))
                  ) {
                    shouldInit = true
                  }
                }
              })
            }

            if (mutation.type === 'attributes' && mutation.target) {
              const drawer =
                mutation.target.closest &&
                mutation.target.closest('site-drawer[key="collection-filters"]')
              if (
                drawer &&
                (mutation.attributeName === 'open' ||
                  mutation.attributeName === 'class')
              ) {
                shouldInit = true
              }
              if (
                mutation.target.matches &&
                mutation.target.matches('facet-search')
              ) {
                shouldInit = true
              }
            }
          } catch (error) {}
        })

        if (shouldInit) {
          setTimeout(initFacetSearch, 100)
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'class'],
      })
    } catch (error) {}
  }

  document.addEventListener(
    'click',
    event => {
      const trigger = event.target.closest(
        '[data-drawers-trigger="collection-filters"]',
      )
      if (trigger) {
        setTimeout(initFacetSearch, 300)
      }
    },
    true,
  )
})()
